import React, { useState } from 'react';
import styles from './UserManagement.module.css';

const UserDetailModal = ({ open, user, onClose, onAddNote, onDeleteNote, onAddTag, onDeleteTag, onAddFile, onDeleteFile, onAddNotification, onDeleteNotification, onAddReminder, onDeleteReminder, onAddTodo, onToggleTodo, onDeleteTodo }) => {
  const [activeTab, setActiveTab] = useState('info');
  const [noteInput, setNoteInput] = useState('');
  const [tagInput, setTagInput] = useState('');
  const [fileName, setFileName] = useState('');
  const [fileUrl, setFileUrl] = useState('');
  const [notificationInput, setNotificationInput] = useState('');
  const [reminderInput, setReminderInput] = useState('');
  const [reminderDate, setReminderDate] = useState('');
  const [todoInput, setTodoInput] = useState('');

  const getRoleClass = (role) => {
    switch (role) {
      case 'admin': return styles.roleAdmin;
      case 'superuser': return styles.roleSuperUser;
      default: return styles.roleUser;
    }
  };

  const getInitials = (name) => {
    if (!name) return '';
    return name.split(' ').map(part => part[0]).join('').toUpperCase().slice(0,2);
  };

  if (!open || !user) return null;

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          {user.avatar ? (
            <img src={user.avatar} alt="avatar" className={styles.avatar} style={{ marginRight: 16 }} />
          ) : (
            <div className={styles.avatarPlaceholder} style={{ marginRight: 16 }}>{getInitials(user.name)}</div>
          )}
          <h2 className={styles.modalTitle}>Kullanıcı Detayları</h2>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button className={styles.closeButton} onClick={onClose} title="Kapat">
              <i className="fas fa-times"></i>
            </button>
            <button className={styles.exitButton} onClick={onClose} title="Çıkış">
              <i className="fas fa-sign-out-alt"></i> Çıkış
            </button>
          </div>
        </div>
        <div className={styles.tabs}>
          <button
            className={`${styles.tab} ${activeTab === 'info' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('info')}
          >
            Bilgiler
          </button>
          <button
            className={`${styles.tab} ${activeTab === 'activity' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('activity')}
          >
            Aktivite
          </button>
          <button
            className={`${styles.tab} ${activeTab === 'permissions' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('permissions')}
          >
            İzinler
          </button>
          <button
            className={`${styles.tab} ${activeTab === 'notes' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('notes')}
          >
            Notlar
          </button>
          <button
            className={`${styles.tab} ${activeTab === 'tags' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('tags')}
          >
            Etiketler
          </button>
          <button
            className={`${styles.tab} ${activeTab === 'files' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('files')}
          >
            Dosyalar
          </button>
          <button
            className={`${styles.tab} ${activeTab === 'notifications' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('notifications')}
          >
            Bildirimler
          </button>
          <button
            className={`${styles.tab} ${activeTab === 'qrcode' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('qrcode')}
          >
            QR Kod
          </button>
          <button
            className={`${styles.tab} ${activeTab === 'reminders' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('reminders')}
          >
            Hatırlatıcılar
          </button>
          <button
            className={`${styles.tab} ${activeTab === 'todos' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('todos')}
          >
            Görevler
          </button>
          <button
            className={`${styles.tab} ${activeTab === 'audit' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('audit')}
          >
            Değişiklik Geçmişi
          </button>
        </div>
        <div className={styles.tabContent}>
          {activeTab === 'info' && (
            <div className={styles.infoContent}>
              <div className={styles.infoGroup}>
                <label className={styles.label}>Ad Soyad</label>
                <p className={styles.infoText}>{user.name}</p>
              </div>
              <div className={styles.infoGroup}>
                <label className={styles.label}>E-posta</label>
                <p className={styles.infoText}>{user.email}</p>
              </div>
              <div className={styles.infoGroup}>
                <label className={styles.label}>Rol</label>
                <span className={`${styles.userRole} ${getRoleClass(user.role)}`}>
                  {user.role === 'admin' ? 'Admin' : user.role === 'superuser' ? 'Super User' : 'User'}
                </span>
              </div>
              <div className={styles.infoGroup}>
                <label className={styles.label}>Durum</label>
                <span className={`${styles.statusBadge} ${user.status === 'active' ? styles.activeStatus : styles.inactiveStatus}`}>
                  {user.status === 'active' ? 'Aktif' : 'Pasif'}
                </span>
              </div>
            </div>
          )}
          {activeTab === 'activity' && (
            <div className={styles.activityContent}>
              <table className={styles.activityTable}>
                <thead>
                  <tr>
                    <th>Tarih</th>
                    <th>İşlem</th>
                    <th>Detay</th>
                    <th>Yapan</th>
                  </tr>
                </thead>
                <tbody>
                  {user.activities?.map((activity, index) => (
                    <tr key={index}>
                      <td>{activity.date ? new Date(activity.date).toLocaleString('tr-TR') : ''}</td>
                      <td>{activity.action}</td>
                      <td>{activity.details}</td>
                      <td>{activity.by || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {activeTab === 'permissions' && (
            <div className={styles.permissionsContent}>
              <div className={styles.permissionGroup}>
                <h3 className={styles.sectionTitle}>Form İzinleri</h3>
                <div className={styles.permissionList}>
                  {Array.isArray(user.permissions?.form) && user.permissions.form.length > 0 ? (
                    user.permissions.form.map((permission, index) => (
                      <div key={index} className={styles.permissionItem}>
                        <span
                          className={permission.granted ? styles.permissionGranted : styles.permissionDenied}
                          title={permission.granted ? "Yetki var" : "Yetki yok"}
                        >
                          <i className={`fas ${permission.granted ? "fa-check-circle" : "fa-times-circle"}`}></i>
                        </span>
                        <span className={styles.permissionName}>{permission.name}</span>
                        {permission.description && (
                          <span className={styles.permissionDescription}>{permission.description}</span>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className={styles.permissionEmpty}>Form izni yok</div>
                  )}
                </div>
              </div>
              <div className={styles.permissionGroup}>
                <h3 className={styles.sectionTitle}>Kullanıcı İzinleri</h3>
                <div className={styles.permissionList}>
                  {Array.isArray(user.permissions?.user) && user.permissions.user.length > 0 ? (
                    user.permissions.user.map((permission, index) => (
                      <div key={index} className={styles.permissionItem}>
                        <span
                          className={permission.granted ? styles.permissionGranted : styles.permissionDenied}
                          title={permission.granted ? "Yetki var" : "Yetki yok"}
                        >
                          <i className={`fas ${permission.granted ? "fa-check-circle" : "fa-times-circle"}`}></i>
                        </span>
                        <span className={styles.permissionName}>{permission.name}</span>
                        {permission.description && (
                          <span className={styles.permissionDescription}>{permission.description}</span>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className={styles.permissionEmpty}>Kullanıcı izni yok</div>
                  )}
                </div>
              </div>
            </div>
          )}
          {activeTab === 'notes' && (
            <div className={styles.notesContent}>
              <form
                onSubmit={e => {
                  e.preventDefault();
                  if (noteInput.trim()) {
                    onAddNote(noteInput);
                    setNoteInput('');
                  }
                }}
                style={{ marginBottom: '1rem' }}
              >
                <input
                  className={styles.input}
                  value={noteInput}
                  onChange={e => setNoteInput(e.target.value)}
                  placeholder="Not ekle..."
                />
                <button type="submit" className={`${styles.button} ${styles.primaryButton}`} style={{ marginLeft: 8 }}>
                  Ekle
                </button>
              </form>
              <ul className={styles.notesList}>
                {user.notes && user.notes.length > 0 ? (
                  user.notes.map((note, idx) => (
                    <li key={idx} className={styles.noteItem}>
                      <span>{note}</span>
                      <button
                        className={styles.deleteButton}
                        style={{ marginLeft: 8 }}
                        onClick={() => onDeleteNote(idx)}
                        title="Notu Sil"
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </li>
                  ))
                ) : (
                  <li className={styles.noteEmpty}>Henüz not yok.</li>
                )}
              </ul>
            </div>
          )}
          {activeTab === 'tags' && (
            <div className={styles.tagsContent}>
              <form
                onSubmit={e => {
                  e.preventDefault();
                  if (tagInput.trim()) {
                    onAddTag(tagInput);
                    setTagInput('');
                  }
                }}
                style={{ marginBottom: '1rem' }}
              >
                <input
                  className={styles.input}
                  value={tagInput}
                  onChange={e => setTagInput(e.target.value)}
                  placeholder="Etiket ekle..."
                />
                <button type="submit" className={`${styles.button} ${styles.primaryButton}`} style={{ marginLeft: 8 }}>
                  Ekle
                </button>
              </form>
              <div className={styles.userTags}>
                {user.tags && user.tags.length > 0 ? (
                  user.tags.map((tag, idx) => (
                    <span key={idx} className={styles.userTag}>
                      {tag}
                      <button
                        className={styles.deleteButton}
                        style={{ marginLeft: 4, fontSize: '0.9em' }}
                        onClick={() => onDeleteTag(idx)}
                        title="Etiketi Sil"
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    </span>
                  ))
                ) : (
                  <span className={styles.noteEmpty}>Henüz etiket yok.</span>
                )}
              </div>
            </div>
          )}
          {activeTab === 'files' && (
            <div className={styles.filesContent}>
              <form
                onSubmit={e => {
                  e.preventDefault();
                  if (fileName.trim() && fileUrl.trim()) {
                    onAddFile({ name: fileName, url: fileUrl });
                    setFileName('');
                    setFileUrl('');
                  }
                }}
                style={{ marginBottom: '1rem', display: 'flex', gap: 8 }}
              >
                <input
                  className={styles.input}
                  value={fileName}
                  onChange={e => setFileName(e.target.value)}
                  placeholder="Dosya adı"
                  style={{ flex: 1 }}
                />
                <input
                  className={styles.input}
                  value={fileUrl}
                  onChange={e => setFileUrl(e.target.value)}
                  placeholder="Dosya URL"
                  style={{ flex: 2 }}
                />
                <button type="submit" className={`${styles.button} ${styles.primaryButton}`}>Ekle</button>
              </form>
              <ul className={styles.filesList}>
                {user.files && user.files.length > 0 ? (
                  user.files.map((file, idx) => (
                    <li key={idx} className={styles.fileItem}>
                      <a href={file.url} target="_blank" rel="noopener noreferrer" className={styles.fileLink}>
                        <i className="fas fa-file-alt"></i> {file.name}
                      </a>
                      <button
                        className={styles.deleteButton}
                        style={{ marginLeft: 8 }}
                        onClick={() => onDeleteFile(idx)}
                        title="Dosyayı Sil"
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </li>
                  ))
                ) : (
                  <li className={styles.noteEmpty}>Henüz dosya yok.</li>
                )}
              </ul>
            </div>
          )}
          {activeTab === 'notifications' && (
            <div className={styles.notificationsContent}>
              <form
                onSubmit={e => {
                  e.preventDefault();
                  if (notificationInput.trim()) {
                    onAddNotification({ message: notificationInput, date: new Date().toISOString() });
                    setNotificationInput('');
                  }
                }}
                style={{ marginBottom: '1rem', display: 'flex', gap: 8 }}
              >
                <input
                  className={styles.input}
                  value={notificationInput}
                  onChange={e => setNotificationInput(e.target.value)}
                  placeholder="Bildirim mesajı..."
                  style={{ flex: 1 }}
                />
                <button type="submit" className={`${styles.button} ${styles.primaryButton}`}>Gönder</button>
              </form>
              <ul className={styles.notificationsList}>
                {user.notifications && user.notifications.length > 0 ? (
                  user.notifications.map((notif, idx) => (
                    <li key={idx} className={styles.notificationItem}>
                      <span className={styles.notificationMsg}>{notif.message}</span>
                      <span className={styles.notificationDate}>{notif.date ? new Date(notif.date).toLocaleString('tr-TR') : ''}</span>
                      <button
                        className={styles.deleteButton}
                        style={{ marginLeft: 8 }}
                        onClick={() => onDeleteNotification(idx)}
                        title="Bildirim Sil"
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </li>
                  ))
                ) : (
                  <li className={styles.noteEmpty}>Henüz bildirim yok.</li>
                )}
              </ul>
            </div>
          )}
          {activeTab === 'qrcode' && (
            <div className={styles.qrContent} style={{ textAlign: 'center', marginTop: 24 }}>
              <div style={{ marginBottom: 12, fontWeight: 500 }}>
                Kullanıcıya özel QR Kod (E-posta):
              </div>
              <img
                src={`https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(user.email)}`}
                alt="QR Kod"
                style={{ width: 180, height: 180, background: '#fff', borderRadius: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
              />
              <div style={{ marginTop: 8, color: '#64748b', fontSize: 13 }}>
                {user.email}
              </div>
            </div>
          )}
          {activeTab === 'reminders' && (
            <div className={styles.remindersContent}>
              <form
                onSubmit={e => {
                  e.preventDefault();
                  if (reminderInput.trim() && reminderDate) {
                    onAddReminder({ message: reminderInput, date: reminderDate });
                    setReminderInput('');
                    setReminderDate('');
                  }
                }}
                style={{ marginBottom: '1rem', display: 'flex', gap: 8 }}
              >
                <input
                  className={styles.input}
                  value={reminderInput}
                  onChange={e => setReminderInput(e.target.value)}
                  placeholder="Hatırlatma mesajı..."
                  style={{ flex: 2 }}
                />
                <input
                  className={styles.input}
                  type="datetime-local"
                  value={reminderDate}
                  onChange={e => setReminderDate(e.target.value)}
                  style={{ flex: 1 }}
                />
                <button type="submit" className={`${styles.button} ${styles.primaryButton}`}>Ekle</button>
              </form>
              <ul className={styles.remindersList}>
                {user.reminders && user.reminders.length > 0 ? (
                  user.reminders.map((rem, idx) => (
                    <li key={idx} className={styles.reminderItem}>
                      <span className={styles.reminderMsg}>{rem.message}</span>
                      <span className={styles.reminderDate}>{rem.date ? new Date(rem.date).toLocaleString('tr-TR') : ''}</span>
                      <button
                        className={styles.deleteButton}
                        style={{ marginLeft: 8 }}
                        onClick={() => onDeleteReminder(idx)}
                        title="Hatırlatıcıyı Sil"
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </li>
                  ))
                ) : (
                  <li className={styles.noteEmpty}>Henüz hatırlatıcı yok.</li>
                )}
              </ul>
            </div>
          )}
          {activeTab === 'todos' && (
            <div className={styles.todosContent}>
              <form
                onSubmit={e => {
                  e.preventDefault();
                  if (todoInput.trim()) {
                    onAddTodo({ text: todoInput, done: false, date: new Date().toISOString() });
                    setTodoInput('');
                  }
                }}
                style={{ marginBottom: '1rem', display: 'flex', gap: 8 }}
              >
                <input
                  className={styles.input}
                  value={todoInput}
                  onChange={e => setTodoInput(e.target.value)}
                  placeholder="Görev ekle..."
                  style={{ flex: 1 }}
                />
                <button type="submit" className={`${styles.button} ${styles.primaryButton}`}>Ekle</button>
              </form>
              <ul className={styles.todosList}>
                {user.todos && user.todos.length > 0 ? (
                  user.todos.map((todo, idx) => (
                    <li key={idx} className={styles.todoItem}>
                      <label style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <input
                          type="checkbox"
                          checked={todo.done}
                          onChange={() => onToggleTodo(idx)}
                        />
                        <span style={{ textDecoration: todo.done ? 'line-through' : 'none', color: todo.done ? '#64748b' : '#1e293b' }}>{todo.text}</span>
                      </label>
                      <span className={styles.todoDate}>{todo.date ? new Date(todo.date).toLocaleString('tr-TR') : ''}</span>
                      <button
                        className={styles.deleteButton}
                        style={{ marginLeft: 8 }}
                        onClick={() => onDeleteTodo(idx)}
                        title="Görevi Sil"
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </li>
                  ))
                ) : (
                  <li className={styles.noteEmpty}>Henüz görev yok.</li>
                )}
              </ul>
            </div>
          )}
          {activeTab === 'audit' && (
            <div className={styles.auditContent}>
              <table className={styles.activityTable}>
                <thead>
                  <tr>
                    <th>Tarih</th>
                    <th>İşlem</th>
                    <th>Detay</th>
                    <th>Yapan</th>
                  </tr>
                </thead>
                <tbody>
                  {user.auditTrail && user.auditTrail.length > 0 ? (
                    user.auditTrail.map((log, idx) => (
                      <tr key={idx}>
                        <td>{log.date ? new Date(log.date).toLocaleString('tr-TR') : ''}</td>
                        <td>{log.action}</td>
                        <td>{log.details}</td>
                        <td>{log.by || '-'}</td>
                      </tr>
                    ))
                  ) : (
                    <tr><td colSpan={4} style={{ color: '#64748b' }}>Henüz değişiklik yok.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserDetailModal; 